import { Outlet } from "react-router-dom";

export function SystemLayout() {
  return (
    <div className="flex min-h-screen w-full justify-center overflow-y-auto bg-bg px-6 py-10">
      <div className="w-full max-w-[var(--ads-max-w)]">
        <Outlet />
      </div>
    </div>
  );
}
